import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Flaky as FlakyIcon,
} from '@mui/icons-material/';

function ModalPapirGameFinishedWithPrize() {
  const { t } = useTranslation();

  const {
    kioskHall,
    updateFocusOnMainScreen,
    updateShowModalPapirGameFinishedWithPrize,
    papirScannedInfo,
    updatePapirScannedInfo,
    userInfo,
    parentInfo,
    operator,
    session,
    hall,
    updateIsLoadingScreen,
    updateTransactions,
    updateTransactionsArray,
    currentUser,
    updateCurrentUser,
    updateUserLogin,
    updateUserInfo,
    maximumAnonPrizeAllowed,
    papirPrize,
    updatePapirPrize,
    updateShowModalPapirCheckCard,
    updatePapirCardInfo,
  } = useContext(AppContext);

  const kioskHallRef = useRef(kioskHall);
  useEffect(() => {
    kioskHallRef.current = kioskHall;
  }, [kioskHall]);

  const papirPrizeRef = useRef(papirPrize);
  useEffect(() => {
    papirPrizeRef.current = papirPrize;
  }, [papirPrize]);

  const maximumAnonPrizeAllowedRef = useRef(maximumAnonPrizeAllowed);
  useEffect(() => {
    maximumAnonPrizeAllowedRef.current = maximumAnonPrizeAllowed;
  }, [maximumAnonPrizeAllowed]);

  const currentUserRef = useRef(currentUser);
  useEffect(() => {
    currentUserRef.current = currentUser;
  }, [currentUser]);

  const hallRef = useRef(hall);
  useEffect(() => {
    hallRef.current = hall;
  }, [hall]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const operatorRef = useRef(operator);
  useEffect(() => {
    operatorRef.current = operator;
  }, [operator]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const papirScannedInfoRef = useRef(papirScannedInfo);
  useEffect(() => {
    papirScannedInfoRef.current = papirScannedInfo;
  }, [papirScannedInfo]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    console.log('ModalPapirGameFinishedWithPrize mounted', papirScannedInfo);
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handlePayoutPapirTicket = async (data) => {
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handlePayoutPapirKingoCard = async (data) => {
      console.log('data payout', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Kingo Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirPrize('');

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handlePayoutPapirXtippCard = async (data) => {
      console.log('data payout', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }

      if (parentInfoRef.current) {
        socket.emit('checkLimitStatus', {
          userInfo: parentInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      if (userInfoRef.current && userInfoRef.current.username !== 'Gjest') {
        socket.emit('checkLimitStatus', {
          userInfo: userInfoRef.current,
          bingoName: hallRef.current,
        });
      }

      let allTrans = [];
      for (let i = 0; i < data.prizes.length; i++) {
        let singleTrans = {
          name: 'Utbetaling Papir Xtipp Billett' + ' - ' + 'CH',
          amount: parseInt(data.prizes[i].amount) * -1,
          type: 'transaction',
        };
        allTrans.push(singleTrans);
      }

      updateTransactionsArray(allTrans);

      updatePapirPrize('');

      updatePapirScannedInfo(false);
      updateFocusOnMainScreen(true);
      updateShowModalPapirGameFinishedWithPrize(false);
    };

    const handleGetPapirCardInfo = async (data) => {
      console.log('data getPapirCardInfo', data);
      updateIsLoadingScreen(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      updatePapirCardInfo(data);
      updateShowModalPapirCheckCard(true);
    };

    socket.on('payoutPapirTicket', handlePayoutPapirTicket);
    socket.on('payoutPapirKingoCard', handlePayoutPapirKingoCard);
    socket.on('payoutPapirXtippCard', handlePayoutPapirXtippCard);
    socket.on('getPapirCardInfo', handleGetPapirCardInfo);
    return () => {
      socket.off('payoutPapirTicket', handlePayoutPapirTicket);
      socket.off('payoutPapirKingoCard', handlePayoutPapirKingoCard);
      socket.off('payoutPapirXtippCard', handlePayoutPapirXtippCard);
      socket.off('getPapirCardInfo', handleGetPapirCardInfo);
    };
  }, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const handleConfirm = async () => {
    if (papirScannedInfoRef.current && papirScannedInfoRef.current.isPayout) {
      return;
    }

    if (
      papirScannedInfoRef.current &&
      papirScannedInfoRef.current.win >= maximumAnonPrizeAllowedRef.current &&
      (((!userInfoRef.current || !userInfoRef.current.username) &&
        !parentInfoRef.current) ||
        (userInfoRef.current &&
          !parentInfoRef.current &&
          userInfoRef.current.username === 'Gjest'))
    ) {
      return;
    }

    updateIsLoadingScreen(true);
    if (!currentUserRef.current) {
      updateCurrentUser('Gjest');
      updateUserLogin(true);
      updateUserInfo({ username: 'Gjest', firstname: 'Gjest' });
    }

    if (papirPrizeRef.current === 'kingo') {
      socket.emit('payoutPapirKingoCard', {
        ticketID: papirScannedInfoRef.current.ticketID,
        prizes: papirScannedInfoRef.current.prizes,
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        userInfo: parentInfoRef.current
          ? parentInfoRef.current
          : userInfoRef.current &&
              userInfoRef.current.username &&
              userInfoRef.current.username !== 'Gjest'
            ? userInfoRef.current
            : { id: '0', '7 digit PIN': 'Gjest' },
        totalAmount: papirScannedInfoRef.current.win,
      });
      return;
    }

    if (papirPrizeRef.current === 'xtipp') {
      socket.emit('payoutPapirXtippCard', {
        ticketID: papirScannedInfoRef.current.ticketID,
        prizes: papirScannedInfoRef.current.prizes,
        operator: operatorRef.current,
        bingoName: hallRef.current,
        sessionID: sessionRef.current,
        userInfo: parentInfoRef.current
          ? parentInfoRef.current
          : userInfoRef.current &&
              userInfoRef.current.username &&
              userInfoRef.current.username !== 'Gjest'
            ? userInfoRef.current
            : { id: '0', '7 digit PIN': 'Gjest' },
        totalAmount: papirScannedInfoRef.current.win,
      });
      return;
    }

    socket.emit('payoutPapirTicket', {
      ticketID: papirScannedInfoRef.current.ticketID,
      prizes: papirScannedInfoRef.current.prizes,
      operator: operatorRef.current,
      bingoName: hallRef.current,
      sessionID: sessionRef.current,
      userInfo: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current &&
            userInfoRef.current.username &&
            userInfoRef.current.username !== 'Gjest'
          ? userInfoRef.current
          : { id: '0', '7 digit PIN': 'Gjest' },
      totalAmount: papirScannedInfoRef.current.win,
    });
  };

  const handleCancel = async () => {
    updatePapirScannedInfo(false);
    updateFocusOnMainScreen(true);
    updateShowModalPapirGameFinishedWithPrize(false);
  };

  const handleCheckCard = async () => {
    updateIsLoadingScreen(true);
    socket.emit('getPapirCardInfo', {
      bingoName: papirScannedInfo.bingoName,
      gameID: papirScannedInfo.gameID,
      ticketID: papirScannedInfo.ticketID,
    });
  };

  return (
    <>
      {kioskHallRef.current === '' ? (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <div
                className="react-confirm-alert-body"
                style={{ width: '1000px' }}
              >
                <h1>{t('sales.papirGameFinishedWithPrizeTitle')} </h1>
                <p>{t('sales.papirGameFinishedWithPrizeText1')}</p>
                {papirScannedInfoRef.current && (
                  <>
                    {papirScannedInfoRef.current.prizes.map(
                      ({ name, amount }, i) => (
                        <p key={i}>
                          {name !== '' && name + ':'}{' '}
                          <strong>{amount} kr</strong>
                        </p>
                      )
                    )}

                    {/* grand total */}
                    <p style={{ marginTop: 8 }}>
                      {t('sales.papirGameFinishedWithPrizeUserTotal')}:{' '}
                      <strong>{papirScannedInfoRef.current.win} kr</strong>
                    </p>
                  </>
                )}

                {papirScannedInfoRef.current &&
                !papirScannedInfoRef.current.isPayout ? (
                  <p>{t('sales.papirGameFinishedWithPrizeText2')}</p>
                ) : (
                  <p style={{ color: 'red' }}>
                    {' '}
                    <strong>
                      {t('sales.papirGameFinishedWithPrizeIsAlreadyPayed')}{' '}
                    </strong>
                  </p>
                )}

                {papirScannedInfoRef.current &&
                  papirScannedInfoRef.current.win >=
                    maximumAnonPrizeAllowedRef.current &&
                  !papirScannedInfoRef.current.isPayout && (
                    <>
                      <p style={{ color: 'red' }}>
                        <strong>
                          {t('sales.papirGameFinishedWithPrizeUserMustBeLogin')}
                        </strong>
                      </p>
                    </>
                  )}
                <div
                  className="react-confirm-alert-button-group"
                  style={{
                    marginTop: '55px',
                  }}
                >
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleConfirm();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                      opacity:
                        (papirScannedInfoRef.current &&
                          papirScannedInfoRef.current.win >=
                            maximumAnonPrizeAllowedRef.current &&
                          (((!userInfoRef.current ||
                            !userInfoRef.current.username) &&
                            !parentInfoRef.current) ||
                            (userInfoRef.current &&
                              !parentInfoRef.current &&
                              userInfoRef.current.username === 'Gjest'))) ||
                        (papirScannedInfoRef.current &&
                          papirScannedInfoRef.current.isPayout)
                          ? 0.25
                          : 1,
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>
                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      handleCancel();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.cancel')}
                  </button>

                  <button
                    className="btn-custom-yes-and-stay"
                    onClick={() => {
                      handleCheckCard();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <FlakyIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.checkCard')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <div
                className="react-confirm-alert-body"
                style={{ width: '1000px' }}
              >
                <h1>{t('sales.papirGameFinishedWithPrizeTitle')} </h1>
                <p>{t('sales.papirGameFinishedWithPrizeText1')}</p>
                {papirScannedInfoRef.current && (
                  <>
                    {papirScannedInfoRef.current.prizes.map(
                      ({ name, amount }, i) => (
                        <p key={i}>
                          {name !== '' && name + ':'}{' '}
                          <strong>{amount} kr</strong>
                        </p>
                      )
                    )}

                    {/* grand total */}
                    <p style={{ marginTop: 8 }}>
                      {t('sales.papirGameFinishedWithPrizeUserTotal')}:{' '}
                      <strong>{papirScannedInfoRef.current.win} kr</strong>
                    </p>
                  </>
                )}

                {papirScannedInfoRef.current &&
                !papirScannedInfoRef.current.isPayout ? (
                  <p>{t('sales.papirGameFinishedWithPrizeText3')}</p>
                ) : (
                  <p style={{ color: 'red' }}>
                    {' '}
                    <strong>
                      {t('sales.papirGameFinishedWithPrizeIsAlreadyPayed')}{' '}
                    </strong>
                  </p>
                )}

                <div
                  className="react-confirm-alert-button-group"
                  style={{
                    marginTop: '55px',
                  }}
                >
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleCancel();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-yes-and-stay"
                    onClick={() => {
                      handleCheckCard();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <FlakyIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.checkCard')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalPapirGameFinishedWithPrize;
